import React, { useState } from "react";
import "./register.scoped.scss";
import IconButton from "@mui/material/IconButton";
import { BiCamera } from "react-icons/bi";
import { DatePicker } from "rsuite";
import axios from "axios";

function Register() {
  const formdata = new FormData();

  const [username, setusername] = useState();
  const [email, setemail] = useState();
  const [number, setnumber] = useState();
  const [age, setage] = useState();
  const [Address, setAddress] = useState();
  const [pincode1, setpincode1] = useState();
  const [pincode2, setpincode2] = useState();
  const [password, setpassword] = useState();
  const [skill, setskill] = useState();
  const [interest, setinterest] = useState();
  const [guidance, setguidance] = useState();
  const [fromdate, setfromdate] = useState();
  const [todate, settodate] = useState();
  const [fromtime, setfromtime] = useState();
  const [totime, settotime] = useState();
  const [role, setrole] = useState();

  const [Partnername, setPartnername] = useState();
  const [Organisationname, setOrganisationname] = useState();
  const [Email, setEmail] = useState();
  const [phonenumber, setphonenumber] = useState();
  const [partnerAddress, setpartnerAddress] = useState();
  const [partnerpassword, setpartnerpassword] = useState();
  const [ProfileImage, setProfileImage] = useState();
  const [PartnerProfileImage, setPartnerProfileImage] = useState();

  var validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  var mobilevalid = /^[6-9][0-9]{9}$/;

  const addPartnerUser = async (e) => {
    e.preventDefault();
    if (!Partnername) {
      alert("Enter Partner name");
      return;
    }
    if (!Organisationname) {
      alert("Enter Organisation Name");
      return;
    }
    if (!phonenumber) {
      alert("Enter Contact Number");
      return;
    }
    if (phonenumber.length != 10) {
      alert("Enter Contact Number should be 10 digits");
      return;
    }
    if (!phonenumber.match(mobilevalid)) {
      alert("Enter Valid Contact Number");
      return;
    }
    if (!Email) {
      alert("Enter email Id");
      return;
    }
    if (!Email.match(validRegex)) {
      alert("Enter Valid Email-Id");
      return;
    }
    if (!partnerAddress) {
      alert("Enter Address");
      return;
    }
    if (!partnerpassword) {
      alert("Enter Password");
      return;
    }

    if (partnerpassword.length < 4) {
      alert("Password must be more than 3 digits");
      return;
    }

    // if (!PartnerProfileImage) {
    //   alert("Please Select Profile Image");
    //   return;
    // }
    formdata.append("Username", Partnername);
    formdata.append("Email", Email);
    formdata.append("Organisationname", Organisationname);
    formdata.append("phonenumber", phonenumber);
    formdata.append("Address", partnerAddress);
    formdata.append("password", partnerpassword);
    formdata.append("UserImage", PartnerProfileImage);

    try {
      const config = {
        url: "/user/addPartner",
        method: "post",
        baseURL: "https://maargdarshak.in/api",
        hearder: { "content-type": "application/json" },

        data: formdata,
      };
      await axios(config).then(function (res) {
        if (res.status === 200) {
          // console.log(res.data);
          alert("Registration Success");
          window.location.assign("/");
        } else {
          alert("Something Wrong");
        }
      });
    } catch (error) {
      console.log(error.response);
      alert(error.response.data.error);
    }
  };

  const addUser = async (e) => {
    e.preventDefault();
    if (!username) {
      alert("Enter Username");
      return;
    }
    if (!email) {
      alert("Enter email Id");
      return;
    }
    if (!email.match(validRegex)) {
      alert("Enter Valid Email-Id");
      return;
    }
    if (!number) {
      alert("Enter Contact Number");
      return;
    }
    if (number.length != 10) {
      alert("Enter Contact Number should be 10 digits");
      return;
    }
    if (!number.match(mobilevalid)) {
      alert("Enter Valid Contact Number");
      return;
    }
    if (!age) {
      alert("Enter Age");
      return;
    }
    if (Number(age) < 0) {
      alert("Age is not less than 0");
      return;
    }
    if (!Address) {
      alert("Enter Address");
      return;
    }
    if (!pincode1) {
      alert("Enter Pincode");
      return;
    }
    if (pincode1.length < 6 || pincode1.length > 6) {
      alert("Enter Pincode should be 6 digits");
      return;
    }
    if (!password) {
      alert("Enter Password");
      return;
    }
    if (password.length < 4) {
      alert("Password must be more than 3 digits");
      return;
    }

    if (!skill) {
      alert("Enter Skill");
      return;
    }
    if (!interest) {
      alert("Enter Interest");
      return;
    }
    if (!guidance) {
      alert("Enter Guidance");
      return;
    }
    if (!role) {
      alert("Select Role");
      return;
    }
    // if (!ProfileImage) {
    //   alert("Please Select Profile Image");
    //   return;
    // }
    formdata.append("Username", username);
    formdata.append("email", email);
    formdata.append("Mobile", number);
    formdata.append("Age", age);
    formdata.append("Address", Address);
    formdata.append("PrimaryPincode", pincode1);
    formdata.append("SecondaryPincode", pincode2);
    formdata.append("password", password);
    formdata.append("skill", skill);
    formdata.append("interest", interest);
    formdata.append("needguidance", guidance);
    formdata.append("fromdate", fromdate);
    formdata.append("todate", todate);
    formdata.append("fromtime", fromtime);
    formdata.append("totime", totime);
    formdata.append("role", role);
    formdata.append("UserImage", ProfileImage);

    try {
      const config = {
        url: "/user/adduser",
        method: "post",
        baseURL: "https://maargdarshak.in/api",
        hearder: { "content-type": "application/json" },

        data: formdata,
      };
      await axios(config).then(function (res) {
        if (res.status === 200) {
          // console.log(res.data);
          alert("Registration Success");
          window.location.assign("/");
        } else {
          alert("Something Wrong");
        }
      });
    } catch (error) {
      console.log(error.response);
      alert(error.response.data.error);
    }
  };

  const [UserRegister, setUserRegister] = useState(true);

  const ChangeUserRegister1 = () => {
    setUserRegister(true);
    setPartnername("");
    setOrganisationname("");
    setEmail("");
    setphonenumber("");
    setpartnerAddress("");
    setpartnerpassword("");
  };

  const ChangeUserRegister2 = () => {
    setUserRegister(false);
    setusername("");
    setemail("");
    setnumber("");
    setage("");
    setAddress("");
    setpincode1("");
    setpassword("");
    setskill("");
    setinterest("");
    setguidance("");
    setfromdate("");
    settodate("");
    setfromtime("");
    settotime("");
    setrole("");
  };
  return (
    <>
      <div
        className=""
        style={
          {
            // backgroundImage:"url('./image/bg.webp')"
          }
        }
      >
        <div class="form_wrapper">
          {" "}
          <div style={{ display: "flex" }}>
            <button
              style={{
                width: "48%",
                backgroundColor: "#0060aa",
                color: "white",
                fontSize: "18px",
                margin: "0% 1%",
                padding: "5px 0px",
              }}
              onClick={() => ChangeUserRegister1()}
            >
              User-Registration
            </button>
            <button
              style={{
                width: "48%",
                backgroundColor: "#0060aa",
                color: "white",
                margin: "0% 1%",

                fontSize: "18px",
              }}
              onClick={() => ChangeUserRegister2()}
            >
              Partner-Registration
            </button>
          </div>
          {UserRegister ? (
            <div class="form_container">
              <div class="title_container">
                <h2>User Registration </h2>
                <figcaption style={{ position: "relative" }}>
                  {!ProfileImage ? (
                    <img
                      src="/image/avatar.png"
                      alt="avatar"
                      style={{
                        width: "151px",
                        height: "151px",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <img
                      src={URL.createObjectURL(ProfileImage)}
                      alt="avatar"
                      style={{
                        width: "151px",
                        height: "151px",
                        borderRadius: "50%",
                      }}
                    />
                  )}

                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      name="file"
                      id="upload1"
                      onChange={(e) => setProfileImage(e.target.files[0])}
                    />
                    <BiCamera />
                  </IconButton>
                </figcaption>
              </div>
              <div class="row clearfix">
                <div class="">
                  <form>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-user"></i>
                      </span>
                      <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        onKeyPress={(event) => {
                          if (!/[a-zA-Z ]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        required
                        value={username}
                        onChange={(e) => {
                          setusername(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-envelope"></i>
                      </span>
                      <input
                        type="email"
                        name="age"
                        placeholder="Email"
                        value={email}
                        required
                        onChange={(e) => {
                          setemail(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-phone"></i>
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        placeholder="Mobile No"
                        value={number}
                        maxLength={10}
                        required
                        onKeyPress={(event) => {
                          if (!/[0-9]|\./.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          setnumber(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i class="fa fa-user-secret" aria-hidden="true"></i>
                      </span>
                      <input
                        type="text"
                        name="age"
                        value={age}
                        onKeyPress={(event) => {
                          if (!/[0-9]|\./.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        maxLength={2}
                        onChange={(e) => {
                          setage(e.target.value);
                        }}
                        placeholder="Age"
                        required
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i class="fa fa-user-secret" aria-hidden="true"></i>
                      </span>
                      <input
                        type="text"
                        name="Address"
                        placeholder="Address"
                        required
                        value={Address}
                        onChange={(e) => {
                          setAddress(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i class="fa fa-user-secret" aria-hidden="true"></i>
                      </span>
                      <input
                        type="number"
                        name="Address"
                        placeholder="Pincode"
                        value={pincode1}
                        onKeyPress={(event) => {
                          if (!/[0-9]|\./.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        maxLength={6}
                        required
                        onChange={(e) => {
                          setpincode1(e.target.value);
                        }}
                      />
                    </div>
                    {/* <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-pencil"></i>
                      </span>
                      <input
                        type="text"
                        name="pincode"
                        placeholder="Pincode"
                        required
                        onChange={(e) => {
                          setpincode2(e.target.value);
                        }}
                      />
                    </div> */}
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-lock"></i>
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        placeholder="Password"
                        required
                        value={password}
                        onChange={(e) => {
                          setpassword(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-lock"></i>
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        placeholder="Skill"
                        required
                        value={skill}
                        onChange={(e) => {
                          setskill(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-lock"></i>
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        placeholder="Interest"
                        required
                        value={interest}
                        onChange={(e) => {
                          setinterest(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-lock"></i>
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        placeholder="What you need guidance on ?"
                        required
                        value={guidance}
                        onChange={(e) => {
                          setguidance(e.target.value);
                        }}
                      />
                    </div>

                    {/* <div class="row clearfix">
            <div class="col_half">
              <div class="input_field"> <span><i aria-hidden="true" class="fa fa-user"></i></span>
                <input type="text" name="name" placeholder="First Name" />
              </div>
            </div>
            <div class="col_half">
              <div class="input_field"> <span><i aria-hidden="true" class="fa fa-user"></i></span>
                <input type="text" name="name" placeholder="Last Name" required />
              </div>
            </div>
          </div> */}
                    {/* <div class="input_field radio_option">
              <input type="radio" name="radiogroup1" id="rd1"/>
              <label for="rd1">Male</label>
              <input type="radio" name="radiogroup1" id="rd2"/>
              <label for="rd2">Female</label>
              </div> */}
                    <div class="input_field select_option">
                      <select
                        onChange={(e) => {
                          setrole(e.target.value);
                        }}
                      >
                        <option value="">Role</option>
                        <option value="Student">Student</option>
                        <option value="Trader">Trader</option>
                        <option value="Buyer-Seller">Buyer-Seller</option>
                        <option value="Teacher">Teacher</option>
                        <option value="Labour">Labour</option>
                        <option value="Artist">Artist</option>
                        <option value="Engineer">Engineer</option>
                        <option value="College Owner">College Owner</option>
                        <option value="School Owner">School Owner</option>
                        <option value="Part Timer">Part Timer</option>
                        <option value="Coder">Coder</option>
                        <option value="Chef">Chef</option>
                        <option value="Cook">Cook</option>
                        <option value="Internship">Internship</option>
                        <option value="Driver">Driver</option>
                        <option value="Professor">Professor</option>
                        <option value="Hacker">Hacker</option>
                        <option value="Tester">Tester</option>
                        <option value="Project manager">Project manager</option>
                        <option value="Others">Others</option>
                      </select>
                      <div class="select_arrow"></div>
                    </div>

                    {role == "Internship" || role == "Part Timer" ? (
                      <>
                        <div className="row" style={{ paddingLeft: "20px" }}>
                          <div className="col-md-6">
                            <div className="input_field">
                              <h6>From date</h6>

                              <input
                                type="date"
                                name="mobile"
                                // placeholder="What you need guidance on ?"
                                required
                                onChange={(e) => {
                                  setfromdate(e.target.value);
                                }}
                              />
                              {/* <DatePicker
                            appearance="default"
                            size="lg"
                            format="yyyy-MM-dd HH:mm:ss"
                            onChange={(e) => {
                              setfromdate(e.target.value);
                            }}
                            ranges={[
                              {
                                label: "Now",
                                value: new Date(),
                              },
                            ]}
                            style={{ width: 240 }}
                          /> */}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input_field">
                              <h6>To date</h6>
                              <input
                                type="date"
                                name="mobile"
                                // placeholder="What you need guidance on ?"
                                required
                                onChange={(e) => {
                                  settodate(e.target.value);
                                }}
                              />
                              {/* <DatePicker
                            appearance="default"
                            size="lg"
                            format="yyyy-MM-dd HH:mm:ss"
                            onChange={(e) => {
                              settodate(e.target.value);
                            }}
                            ranges={[
                              {
                                label: "Now",
                                value: new Date(),
                              },
                            ]}
                            style={{ width: 240 }}
                          /> */}
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ paddingLeft: "20px" }}>
                          <div className="col-md-6">
                            <div className="input_field">
                              <h6>From Time</h6>

                              <input
                                type="time"
                                name="mobile"
                                // placeholder="What you need guidance on ?"
                                required
                                onChange={(e) => {
                                  setfromtime(e.target.value);
                                }}
                              />
                              {/* <DatePicker
                            appearance="default"
                            size="lg"
                            format="yyyy-MM-dd HH:mm:ss"
                            onChange={(e) => {
                              setfromdate(e.target.value);
                            }}
                            ranges={[
                              {
                                label: "Now",
                                value: new Date(),
                              },
                            ]}
                            style={{ width: 240 }}
                          /> */}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input_field">
                              <h6>To Time</h6>
                              <input
                                type="time"
                                name="mobile"
                                // placeholder="What you need guidance on ?"
                                required
                                onChange={(e) => {
                                  settotime(e.target.value);
                                }}
                              />
                              {/* <DatePicker
                            appearance="default"
                            size="lg"
                            format="yyyy-MM-dd HH:mm:ss"
                            onChange={(e) => {
                              settodate(e.target.value);
                            }}
                            ranges={[
                              {
                                label: "Now",
                                value: new Date(),
                              },
                            ]}
                            style={{ width: 240 }}
                          /> */}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {/* <div class="input_field checkbox_option">
              <input type="checkbox" id="cb1"/>
          <label for="cb1">I agree with terms and conditions</label>
            </div>
            <div class="input_field checkbox_option">
              <input type="checkbox" id="cb2"/>
          <label for="cb2">I want to receive the newsletter</label>
            </div> */}
                    <input
                      class="button"
                      type="submit"
                      value="Register"
                      onClick={(e) => addUser(e)}
                    />
                    <div>
                      Already have an account?<a href="/login">Login</a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          ) : (
            <div class="form_container">
              <div class="title_container">
                <h2>Partner Registration </h2>
                <figcaption style={{ position: "relative" }}>
                  {!PartnerProfileImage ? (
                    <img
                      src="/image/avatar.png"
                      alt="avatar"
                      style={{
                        width: "151px",
                        height: "151px",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <img
                      src={URL.createObjectURL(PartnerProfileImage)}
                      alt="avatar"
                      style={{
                        width: "151px",
                        height: "151px",
                        borderRadius: "50%",
                      }}
                    />
                  )}

                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      name="file"
                      id="upload2"
                      onChange={(e) =>
                        setPartnerProfileImage(e.target.files[0])
                      }
                    />
                    <BiCamera />
                  </IconButton>
                </figcaption>
              </div>
              <div class="row clearfix">
                <div class="">
                  <form>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-user"></i>
                      </span>
                      <input
                        type="text"
                        name="name1"
                        placeholder="Partner Name"
                        value={Partnername}
                        required
                        onKeyPress={(event) => {
                          if (!/[a-zA-Z ]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          setPartnername(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i class="fa fa-building" aria-hidden="true"></i>
                      </span>
                      <input
                        type="text"
                        name="age"
                        value={Organisationname}
                        placeholder="Organisation Name"
                        required
                        onChange={(e) => {
                          setOrganisationname(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i aria-hidden="true" class="fa fa-phone"></i>
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        value={phonenumber}
                        placeholder="Mobile No"
                        maxLength={10}
                        required
                        onKeyPress={(event) => {
                          if (!/[0-9]|\./.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          setphonenumber(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                      </span>
                      <input
                        type="text"
                        name="age"
                        value={Email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        placeholder="Email"
                        required
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i class="fa fa-user-secret" aria-hidden="true"></i>
                      </span>
                      <input
                        type="text"
                        name="Address"
                        placeholder="Address"
                        required
                        value={partnerAddress}
                        onChange={(e) => {
                          setpartnerAddress(e.target.value);
                        }}
                      />
                    </div>
                    <div class="input_field">
                      {" "}
                      <span>
                        <i class="fa fa-lock" aria-hidden="true"></i>
                      </span>
                      <input
                        type="text"
                        name="Address"
                        placeholder="Password"
                        required
                        // maxLength={8}
                        value={partnerpassword}
                        onChange={(e) => {
                          setpartnerpassword(e.target.value);
                        }}
                      />
                    </div>

                    {/* <div class="row clearfix">
            <div class="col_half">
              <div class="input_field"> <span><i aria-hidden="true" class="fa fa-user"></i></span>
                <input type="text" name="name" placeholder="First Name" />
              </div>
            </div>
            <div class="col_half">
              <div class="input_field"> <span><i aria-hidden="true" class="fa fa-user"></i></span>
                <input type="text" name="name" placeholder="Last Name" required />
              </div>
            </div>
          </div> */}
                    {/* <div class="input_field radio_option">
              <input type="radio" name="radiogroup1" id="rd1"/>
              <label for="rd1">Male</label>
              <input type="radio" name="radiogroup1" id="rd2"/>
              <label for="rd2">Female</label>
              </div> */}

                    {/* <div class="input_field checkbox_option">
              <input type="checkbox" id="cb1"/>
          <label for="cb1">I agree with terms and conditions</label>
            </div>
            <div class="input_field checkbox_option">
              <input type="checkbox" id="cb2"/>
          <label for="cb2">I want to receive the newsletter</label>
            </div> */}
                    <input
                      class="button"
                      type="submit"
                      value="Register"
                      onClick={(e) => addPartnerUser(e)}
                    />
                    <div>
                      Already have an account?<a href="/Partnerlogin">Login</a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Register;
